import store from '@/store';
import DafApi from '@/api/DafApi';

export const createDafOrgUser = ({ commit }, orgAndUser) => {
  console.log(commit);
  store.dispatch('application/startLoading');
  return DafApi.createDafOrgUser(orgAndUser)
    .then((response) => {
      store.dispatch('application/finishLoading');
      return response;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      return Promise.reject(error);
    });
};

export default {
  createDafOrgUser,
};



// WEBPACK FOOTER //
// ./src/store/modules/daf/actions.js